var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37821 9.73477L0.257567 2.40132C-0.0858556 2.04764 -0.0858556 1.47422 0.257567 1.12058L1.08808 0.265254C1.43091 -0.0878259 1.98655 -0.0885054 2.33019 0.263745L8.00002 6.07563L13.6698 0.263745C14.0134 -0.0885054 14.5691 -0.0878259 14.9119 0.265254L15.7424 1.12058C16.0859 1.47426 16.0859 2.04767 15.7424 2.40132L8.62183 9.73477C8.27841 10.0884 7.72163 10.0884 7.37821 9.73477Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/DownArrowIcon.69ae5f67240a759c3686a0fa57a3b930.svg";
export { ForwardRef as ReactComponent };